import { ActivityGroupDTORead } from "../models/ActivityDTO";
import { ApiResult } from "../models/ApiResult";
import { ApiRequest } from "./service.base";


export class ActivityGroupRequest  extends ApiRequest<ActivityGroupDTORead,ApiResult> {
    constructor(endpoint: string, token: string) {
        super(endpoint, token)
    }
}